import React, { useRef, useState} from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Grid, Card, IconButton, CardMedia, Box, TableHead } from "@mui/material";
// import { CustomBtn } from "../../../../components/button/button";
// import html2canvas from 'html2canvas';
import { useSelector } from "react-redux";
import { Height } from "@mui/icons-material";
// import '../sales.scss'
const PrintBillDialog = ({ open, onClose, studentData }) => {
    // console.log(studentData?.customer_contact)
    // console.log(studentData   )
    // console.log(studentData?.result[0])
    const [webSrn, setWebSrn] = useState(localStorage.getItem('WebSrn'));
    const paymentDetails = studentData?.result[0];
    let phoneNumber = ''
    const loginUser = localStorage.getItem('loggedInUser')
        const billContentRef =  useRef(null);
        const changeBillDate = (value) => {
                const cleanValue = value?.replace(/(\d+)(st|nd|rd|th)/, '$1');

            const event = new Date(cleanValue);
            // console.log(event)
            if (isNaN(event.getTime())) return value; // fallback if date is invalid
            const locale = 'fa-IR'
            if (locale === 'fa-IR') {
                const arr = ['دی', 'بهمن', 'اسفند', 'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر'];
                const convertmonths = ['جدی', 'دلو', 'حوت', 'حمل', 'ثور', 'جوزا', 'سرطان', 'اسد', 'سنبله', 'میزان', 'عقرب', 'قوس'];

                const getMonth = event.toLocaleDateString(locale, { month: 'long' });
                const currentDate = event.toLocaleDateString(locale, { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' });
                const getIndMonth = arr.indexOf(getMonth);
            // console.log(getIndMonth)
                return currentDate.replace(getMonth, convertmonths[getIndMonth]);
            }

            return event.toLocaleDateString(locale, {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
            };
        

        const handlePrint = () => {
            const printWindow = window.open('', '', 'width=600,height=600');
            const content = billContentRef.current?.innerHTML; // Get the content from the ref
            // console.log(content)
            if (content) {
              printWindow.document.write(`
                        <html>
                            <head>
                            <title>Bill</title>
                            <style>
                                body {
                                font-family: Arial, sans-serif;
                                margin: 0;
                                padding: 0;
                                }
                                .print-container {
                                width: 300px;
                                margin: 0 auto;
                                padding: 10px;
                                background-color: white;
                                }
                                table {
                                width: 100%;
                                border-collapse: collapse;
                                }
                                td, th {
                                border: none; /* or border: 1px solid #000 if needed */
                                padding: 4px;
                                }
                            </style>
                            </head>
                            <body>
                            <div class="print-container">
                                ${content}
                            </div>
                            </body>
                        </html>
                        `);


              printWindow.document.close();
                printWindow.focus();
                setTimeout(() => {
                printWindow.print();
                printWindow.close();
                }, 500);

            } else {
              console.error('No content to print.');
            }
          };
        
              
        return (
            <Dialog open={open} onClose={onClose}> 
                <DialogContent>
                <div id="bill-content" ref={billContentRef}  style={{ width: '300px', maxWidth: '300px', padding: '10px', backgroundColor: 'white' }}>
                    <Box>{ 
                        webSrn == 1 ?
                            <>  
                                <Box><h2 style={{textAlign:'center', margin:'0px'}}>اظهار خصوصي ښوونځي</h2></Box>
                                <Box><p className='loanOrcash' style={{textAlign:'center', margin:'0px', fontWeight:'bold', marginBottom:'10px'}}>Azhar Private School</p></Box>
                            </>
                        : webSrn == 3 ?
                            <>  
                                <Box><h2 style={{textAlign:'center', margin:'0px'}}>حکيم الامت دارالعلوم</h2></Box>
                                {/* <Box><p className='loanOrcash' style={{textAlign:'center', margin:'0px', fontWeight:'bold', marginBottom:'10px'}}>Rawayat Private School & Kindergarten</p></Box> */}
                            </>
                        : webSrn == 7 ?
                            <>  
                                <Box><h2 style={{textAlign:'center', margin:'0px'}}>لیسه عالی خصوصی ندای روشن</h2></Box>
                                <Box><p className='loanOrcash' style={{textAlign:'center', margin:'0px', fontWeight:'bold', marginBottom:'10px'}}>Neda E Roshan Private High School</p></Box>
                            </>
                          : webSrn == 8 ?
                            <>  
                                <Box><h2 style={{textAlign:'center', margin:'0px'}}>روايت خصوصي ښوونځی او وړکتون</h2></Box>
                                <Box><p className='loanOrcash' style={{textAlign:'center', margin:'0px', fontWeight:'bold', marginBottom:'10px'}}>Rawayat Private School & Kindergarten</p></Box>
                            </>
                        : webSrn == 9 ?
                            <>  
                                <Box><h2 style={{textAlign:'center', margin:'0px'}}>هوډ خصوصي لېسه</h2></Box>
                                <Box><p className='loanOrcash' style={{textAlign:'center', margin:'0px', fontWeight:'bold', marginBottom:'10px'}}>Hod Private School</p></Box>
                            </>
                        : webSrn == 10 ?
                            <>  
                                <Box><h2 style={{textAlign:'center', margin:'0px'}}>المبارک ځلاند خصوصي ښوونځی</h2></Box>
                                <Box><p className='loanOrcash' style={{textAlign:'center', margin:'0px', fontWeight:'bold', marginBottom:'10px'}}>AlMubarak Private School</p></Box>
                            </>
                        
                        : webSrn == 11 ?
                            <>  
                                <Box><h2 style={{textAlign:'center', margin:'0px'}}>براق خصوصی ښوونځي</h2></Box>
                                <Box><p className='loanOrcash' style={{textAlign:'center', margin:'0px', fontWeight:'bold', marginBottom:'10px'}}>Buraq Private School</p></Box>
                            </>
                        
                        : webSrn == 12 ?
                            <>  
                                <Box><h2 style={{textAlign:'center', margin:'0px'}}>مکتب خصوصی عثمان دانش</h2></Box>
                                <Box><p className='loanOrcash' style={{textAlign:'center', margin:'0px', fontWeight:'bold', marginBottom:'10px'}}>Osman Danish Private High School</p></Box>
                            </>
                        : webSrn == 13 ?
                            <>  
                                <Box><h2 style={{textAlign:'center', margin:'0px'}}>روايت اکاډمــي</h2></Box>
                                <Box><p className='loanOrcash' style={{textAlign:'center', margin:'0px', fontWeight:'bold', marginBottom:'10px'}}>Rawayat Academy</p></Box>
                            </>
                        :  
                        webSrn == 14 ?
                            <>  
                                <Box><h2 style={{textAlign:'center', margin:'0px'}}>لیسه عالی خصوصی نایاب شهر</h2></Box>
                                <Box><p className='loanOrcash' style={{textAlign:'center', margin:'0px', fontWeight:'bold', marginBottom:'10px'}}>Nayab Shahr Private High School</p></Box>
                            </>
                        :  
                            <>  
                                <Box><h2 style={{textAlign:'center', margin:'0px'}}>واصلي ټیکنالوژی </h2></Box>
                                <Box><p className='loanOrcash' style={{textAlign:'center', margin:'0px', fontWeight:'bold', marginBottom:'10px'}}>Wasily Technology</p></Box>
                            </>
                         
                    } 
                    </Box>
                    <Box><p style={{fontSize:'12px', margin:'0px'}}>Recipt #: {paymentDetails?.Srn}</p></Box> 
                    <Box><p style={{fontSize:'12px', margin:'0px'}}>Date: <span style={{fontWeight:'bold', fontSize:'14px'}}>{changeBillDate(paymentDetails?.Date)}</span></p></Box> 
                    <Box><p className='loanOrcash' style={{textAlign:'center', marginTop:'10px', marginBottom: '10px', backgroundColor:'red#f5f5f5', fontSize:'24px', fontWeight:'bold'}}>رسید پاڼه</p></Box> 
                        <table style={{width:'290px'}}>
                            <thead>
                                <tr>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{fontSize:'14px'}}>{studentData?.StudentDetails?.RollNum}</td>
                                    <td style={{width:'100px', fontSize:'16px', fontWeight:'bold'}}>اساس/رول نمبر</td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:'14px'}}>{studentData?.StudentDetails?.Name_P}</td>
                                    <td style={{width:'100px', fontSize:'16px', fontWeight:'bold'}}>نوم</td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:'14px'}}>{studentData?.StudentDetails?.FName_P}</td>
                                    <td style={{width:'100px', fontSize:'16px', fontWeight:'bold'}}>پلار نوم</td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:'14px'}}>{studentData?.StudentDetails?.Class}</td>
                                    <td style={{width:'100px', fontSize:'16px', fontWeight:'bold'}}>صنف</td>
                                </tr>
                                {studentData?.StudentDetails?.Discount > 0? 
                                <tr>
                                    <td style={{fontSize:'14px'}}>{studentData?.StudentDetails?.Discount}</td>
                                    <td style={{width:'100px', fontSize:'16px', fontWeight:'bold'}}>تخفیف</td>
                                </tr>
                                : null
                                }
                                <tr>
                                    <td style={{fontSize:'14px'}}>{studentData?.StudentDetails?.MonthlyFee}</td>
                                    <td style={{width:'100px', fontSize:'16px', fontWeight:'bold'}}>میاشتنی فیس</td>
                                </tr>
                            </tbody>
                            
                        </table>
                    <Box><p className='loanOrcash' style={{textAlign:'center', backgroundColor:'red#f5f5f5', marginTop:'10px', marginBottom: '10px', fontSize:'24px', fontWeight:'bold'}}>فیس</p></Box> 
                        <table style={{width:'290px'}}>
                            <thead>
                                <tr>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{fontSize:'14px', fontWeight:'bold'}}>{studentData?.result?.[0]?.["Paid Amount"]}</td>
                                    <td style={{width:'100px', fontSize:'16px', fontWeight:'bold'}}>رسید مبلغ</td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:'14px', fontWeight:'bold'}}>{studentData?.FeesDetials?.reduceamount}</td>
                                    <td style={{width:'100px', fontSize:'16px', fontWeight:'bold'}}>بقایاجات</td>
                                </tr> 
                            </tbody>
                            
                        </table>
                    <Box><p className='loanOrcash' style={{textAlign:'center', fontSize:'20px', fontWeight:'bold'}}> </p></Box> 
                        <table style={{width:'290px'}}>
                         <thead>
                            <tr>
                                <td> </td>
                                <td></td>
                            </tr>
                        </thead>  
                        <tbody>
                            {/* <tr>
                                <td colSpan={3}>SalesPerson: {loginUser}</td>
                            </tr> */}
                            <tr>
                                <td style={{textAlign:'center', fontSize:'18px'}} className="pashtoThanks"  colSpan={4}>ډیره مننه</td>
                            </tr>
                            <tr>                                
                                <td colSpan={4} style={{textAlign:'center', fontSize:'12px'}}>Wasily Technology <b>www.Wasily.net</b></td>
                            </tr>
                        </tbody>
                    </table> 
                    </div>
                </DialogContent>
                <Grid container lg={12} className='bottomTotal'>
                    <Grid xs={4} lg={4}>
                        <DialogActions>
                            <Button onClick={onClose} color="primary" variant="contained">OK</Button>
                        </DialogActions>
                    </Grid>
                    <Grid xs={4} lg={4}>
                        <DialogActions>
                            <Button onClick={handlePrint} color="primary" variant="contained">Print</Button>
                        </DialogActions>
                    </Grid>
                    <Grid xs={4} lg={4}>
                        <DialogActions>
                            {/* <Button color="primary" onClick={sendBillToWhatsApp} variant="contained">WhatsApp</Button> */}
                        </DialogActions>
                    </Grid>
                </Grid>



            </Dialog>
        );
    };

    export default PrintBillDialog;
